/**
 * Formats a price number with thousands separator and 2 decimal places.
 * e.g. 1200 → "1,200.00"  |  350 → "350.00"
 */
export function formatPrice(price: number): string {
  return price.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
